/* GlamStation theme.js — small interactions, no framework */

(function () {
  'use strict';

  // ─── Mobile drawer ─────────────────────────────────────────
  const drawer = document.querySelector('[data-gs-drawer]');
  const burger = document.querySelector('[data-gs-drawer-open]');
  const closeBtn = document.querySelector('[data-gs-drawer-close]');
  const scrim = document.querySelector('[data-gs-drawer-scrim]');

  function openMobileDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openMobileDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileDrawer);
  if (scrim) scrim.addEventListener('click', closeMobileDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileDrawer();
      closeCartDrawer();
    }
  });

  // ─── Marquee duplication ───────────────────────────────────
  document.querySelectorAll('[data-gs-marquee]').forEach(function (el) {
    const track = el.querySelector('.gs-marquee__track');
    if (!track) return;
    const html = track.innerHTML;
    track.innerHTML = html + html + html;
  });

  // ─── Countdown ─────────────────────────────────────────────
  document.querySelectorAll('[data-gs-countdown]').forEach(function (el) {
    const target = new Date(el.getAttribute('data-gs-countdown')).getTime();
    if (isNaN(target)) return;
    function tick() {
      const diff = Math.max(0, target - Date.now());
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff / 3600000) % 24);
      const mins = Math.floor((diff / 60000) % 60);
      const secs = Math.floor((diff / 1000) % 60);
      const pad = function (n) { return String(n).padStart(2, '0'); };
      const set = function (sel, v) { const el2 = el.querySelector(sel); if (el2) el2.textContent = v; };
      set('[data-d]', pad(days) + 'd');
      set('[data-h]', pad(hours) + 'h');
      set('[data-m]', pad(mins) + 'm');
      set('[data-s]', pad(secs) + 's');
    }
    tick();
    setInterval(tick, 1000);
  });

  // ─── Money formatter ───────────────────────────────────────
  // Shopify ships prices as cents. We format MXN with thin separators.
  const moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  function formatMoney(cents) {
    const n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: moneyFormat, minimumFractionDigits: 2 }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  // ─── Cart count ────────────────────────────────────────────
  function setCartCount(count) {
    document.querySelectorAll('[data-gs-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      if (count > 0) el.removeAttribute('hidden');
    });
  }

  // ─── Cart drawer ──────────────────────────────────────────
  const cartDrawer = document.querySelector('[data-gs-cart-drawer]');
  const cartList = document.querySelector('[data-gs-cart-list]');
  const cartEmpty = document.querySelector('[data-gs-cart-empty]');
  const cartFoot = document.querySelector('[data-gs-cart-foot]');
  const cartTitle = document.querySelector('[data-gs-cart-title]');
  const cartSubtotal = document.querySelector('[data-gs-cart-subtotal]');
  const lineTpl = document.querySelector('[data-gs-cart-line-template]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-gs-cart-close], [data-gs-cart-close-link]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.tagName === 'A' && el.hasAttribute('href')) return;
      e.preventDefault();
      closeCartDrawer();
    });
  });

  // Open drawer when clicking cart icon (only elements with data-gs-cart-open opt in)
  document.querySelectorAll('[data-gs-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      fetchCart().then(renderCart).then(openCartDrawer);
    });
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    if (!cartDrawer || !cartList) return cart;
    setCartCount(cart.item_count);
    cartList.innerHTML = '';

    if (cart.item_count === 0) {
      if (cartTitle) cartTitle.textContent = 'aún sin productos.';
      if (cartEmpty) cartEmpty.removeAttribute('hidden');
      if (cartFoot) cartFoot.setAttribute('hidden', '');
      return cart;
    }

    if (cartEmpty) cartEmpty.setAttribute('hidden', '');
    if (cartFoot) cartFoot.removeAttribute('hidden');
    if (cartTitle) cartTitle.textContent = cart.item_count + (cart.item_count === 1 ? ' item.' : ' items.');
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    cart.items.forEach(function (item) {
      if (!lineTpl) return;
      const node = lineTpl.content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      const imgUrl = node.querySelector('[data-line-url]');
      const img = node.querySelector('[data-line-img]');
      const brand = node.querySelector('[data-line-brand]');
      const titleUrl = node.querySelector('[data-line-title-url]');
      const title = node.querySelector('[data-line-title]');
      const variant = node.querySelector('[data-line-variant]');
      const qty = node.querySelector('[data-line-qty]');
      const price = node.querySelector('[data-line-price]');

      if (imgUrl) imgUrl.href = item.url;
      if (titleUrl) titleUrl.href = item.url;
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2');
          img.alt = item.title;
        } else {
          img.style.background = 'var(--gs-cream-2)';
          img.style.minHeight = '80px';
        }
      }
      if (brand) brand.textContent = item.vendor || '';
      if (title) title.textContent = (item.product_title || '').toLowerCase();
      if (variant && item.variant_title && !item.variant_title.toLowerCase().includes('default')) {
        variant.textContent = item.variant_title.toLowerCase();
        variant.removeAttribute('hidden');
      }
      if (qty) qty.textContent = item.quantity;
      if (price) price.textContent = formatMoney(item.final_line_price);

      node.querySelector('[data-line-inc]').addEventListener('click', function () {
        updateLine(item.key, item.quantity + 1);
      });
      node.querySelector('[data-line-dec]').addEventListener('click', function () {
        updateLine(item.key, Math.max(0, item.quantity - 1));
      });
      node.querySelector('[data-line-remove]').addEventListener('click', function () {
        updateLine(item.key, 0);
      });

      cartList.appendChild(node);
    });

    return cart;
  }

  function updateLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // If we're on the cart page, reload to keep server-rendered cart in sync.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      });
  }

  // ─── AJAX add-to-cart ──────────────────────────────────────
  document.querySelectorAll('form[action$="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'agregando…';
      }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          renderCart(cart);
          openCartDrawer();
          if (submitBtn) {
            submitBtn.innerHTML = '✓ agregado';
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
            }, 1500);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function (err) {
          console.error('add-to-cart error', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = (err && err.description) ? 'sin stock' : 'error · reintenta';
            setTimeout(function () { submitBtn.innerHTML = originalText; }, 2000);
          }
        });
    });
  });

  // Initial cart count refresh
  fetchCart().then(renderCart).catch(function () {});

  // Listen to legacy cart updates
  document.addEventListener('cart:updated', function (e) {
    if (e.detail) setCartCount(e.detail.item_count);
  });

  // ─── PDP gallery swap + counter sync ───────────────────────
  document.querySelectorAll('[data-gs-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gs-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gs-gallery-thumb]');
    const counter = gallery.querySelector('[data-gs-gallery-counter-current]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        const full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-current', 'false'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        if (counter) {
          const idx = thumb.getAttribute('data-gs-gallery-index') || '1';
          counter.textContent = ('00' + idx).slice(-2);
        }
      });
    });
  });

  // ─── PDP save (visual toggle only — no persistence until Fase 6) ──
  document.querySelectorAll('[data-gs-save]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-saved');
      const saved = btn.classList.contains('is-saved');
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  });

  // ─── Expandable accordions (PDP sections) ──────────────────
  document.querySelectorAll('[data-gs-accordion]').forEach(function (acc) {
    const head = acc.querySelector('[data-gs-accordion-head]');
    if (!head) return;
    head.addEventListener('click', function () {
      acc.classList.toggle('is-open');
      const expanded = acc.classList.contains('is-open');
      head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  // ─── Cart page +/- controls ───────────────────────────────
  document.querySelectorAll('[data-cart-page-qty]').forEach(function (input) {
    const key = input.dataset.key;
    const dec = document.querySelector('[data-cart-page-dec][data-key="' + key + '"]');
    const inc = document.querySelector('[data-cart-page-inc][data-key="' + key + '"]');
    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value, 10) - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // ─── PDP quantity controls + total/sticky sync ─────────────
  document.querySelectorAll('[data-gs-qty-input]').forEach(function (input) {
    const dec = input.parentElement.querySelector('[data-gs-qty-dec]');
    const inc = input.parentElement.querySelector('[data-gs-qty-inc]');
    // Reach the price node — it lives on the main info column, not inside .gs-pdp__qty.
    const priceNode = document.querySelector('[data-gs-price-pesos]');
    const totalDisp = document.querySelector('[data-gs-total-display]');
    const stickyQty = document.querySelector('[data-gs-sticky-qty]');
    const unitPesos = priceNode ? parseInt(priceNode.getAttribute('data-gs-price-pesos'), 10) || 0 : 0;

    function syncDerived() {
      const q = Math.max(1, parseInt(input.value, 10) || 1);
      if (totalDisp && unitPesos) {
        totalDisp.textContent = '$' + (unitPesos * q).toLocaleString('es-MX');
      }
      if (stickyQty) stickyQty.textContent = String(q);
    }

    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      input.dispatchEvent(new Event('change'));
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change'));
    });
    input.addEventListener('change', syncDerived);
    input.addEventListener('input', syncDerived);
    syncDerived();
  });

  // ─── PDP variant pickers (custom radio styling) ────────────
  document.querySelectorAll('[data-gs-variant-options]').forEach(function (group) {
    const radios = group.querySelectorAll('input[type="radio"]');
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        radios.forEach(function (x) {
          x.parentElement.classList.toggle('is-active', x.checked);
        });
      });
    });
    // Set initial state
    radios.forEach(function (r) {
      if (r.checked) r.parentElement.classList.add('is-active');
    });
  });

  // Note: the old initCollectionFilters() IIFE (client-side hide/show)
  // was removed in Fase C. Catalog filtering is now server-side via URL
  // params — every chip/pill/checkbox/concern is an <a href> link that
  // navigates to a new URL. Sort uses <select onchange="this.form.submit()">
  // inside a <form>. No JS needed for filter logic.

  // ─── Search submit ─────────────────────────────────────────
  document.querySelectorAll('[data-gs-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) e.preventDefault();
    });
  });

  // ─── Keyboard shortcut for search (⌘K / Ctrl+K) ────────────
  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      const input = document.querySelector('[data-gs-search-form] input[name="q"]');
      if (input) {
        e.preventDefault();
        input.focus();
      }
    }
  });

  // ─── Collection filters · mobile bottom-sheet drawer (Fase C) ───
  // The desktop sidebar (.gs-filters) is always visible ≥ 920px via CSS.
  // The mobile drawer (.gs-bsheet) mirrors the same filter groups and
  // slides up from the bottom when the toolbar toggle is pressed. Backdrop
  // + ESC + outside-click close it. No filter logic here — all filter
  // changes are <a href> links that navigate to a new URL.
  const filtersToggle   = document.querySelector('[data-gs-filters-open]');
  const filtersSheet    = document.querySelector('[data-gs-filters-sheet]');
  const filtersBackdrop = document.querySelector('[data-gs-filters-backdrop]');
  const filtersClose    = document.querySelector('[data-gs-filters-close]');
  function openFiltersSheet() {
    if (!filtersSheet) return;
    filtersSheet.classList.add('is-open');
    filtersSheet.setAttribute('aria-hidden', 'false');
    if (filtersBackdrop) filtersBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFiltersSheet() {
    if (!filtersSheet) return;
    filtersSheet.classList.remove('is-open');
    filtersSheet.setAttribute('aria-hidden', 'true');
    if (filtersBackdrop) filtersBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (filtersToggle)   filtersToggle.addEventListener('click', openFiltersSheet);
  if (filtersClose)    filtersClose.addEventListener('click', closeFiltersSheet);
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFiltersSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFiltersSheet();
  });

  // ─── Collection client-side filter + sort (Fase C.1) ────────
  // Shopify Liquid doesn't expose URL query params (request.params
  // is not a thing — only design_mode/host/locale/origin/page_type/
  // path are available). Filters live entirely in the URL and are
  // applied client-side: read URLSearchParams, hide non-matching
  // cards via .is-hidden, re-order the grid by sort, render the
  // applied-chips toolbar, sync sidebar visual state, update counter.
  //
  // URL contract:
  //   ?filter.category=X       single
  //   ?filter.vendor=a,b,c     multi (comma-separated)
  //   ?filter.concern=a,b      multi
  //   ?filter.on_sale=1        bool
  //   ?filter.drop=1           bool
  //   ?filter.price_min=200    integer (MXN pesos)
  //   ?filter.price_max=800
  //   ?filter.sort=price-asc   manual|novedad|price-asc|price-desc|title-asc
  (function initCollectionFilterClient() {
    const grid = document.querySelector('[data-gs-cards-grid]');
    if (!grid) return;

    const cards      = Array.from(grid.querySelectorAll('[data-gs-card]'));
    const emptyEl    = document.querySelector('[data-gs-empty]');
    const chipsHost  = document.querySelector('[data-gs-applied-chips]');
    const sortSelect = document.querySelector('[data-gs-sort-select]');
    const priceForm  = document.querySelector('[data-gs-price-form]');

    function parseState() {
      const p = new URLSearchParams(location.search);
      return {
        category: p.get('filter.category') || '',
        vendor:  (p.get('filter.vendor')  || '').split(',').filter(Boolean),
        concern: (p.get('filter.concern') || '').split(',').filter(Boolean),
        onSale:   p.get('filter.on_sale') === '1',
        onDrop:   p.get('filter.drop') === '1',
        priceMin: parseInt(p.get('filter.price_min') || '', 10) || null,
        priceMax: parseInt(p.get('filter.price_max') || '', 10) || null,
        sort:     p.get('filter.sort') || 'manual',
      };
    }

    function buildURL(state) {
      const p = new URLSearchParams();
      if (state.category) p.set('filter.category', state.category);
      if (state.vendor.length)  p.set('filter.vendor',  state.vendor.join(','));
      if (state.concern.length) p.set('filter.concern', state.concern.join(','));
      if (state.onSale) p.set('filter.on_sale', '1');
      if (state.onDrop) p.set('filter.drop', '1');
      if (state.priceMin != null) p.set('filter.price_min', state.priceMin);
      if (state.priceMax != null) p.set('filter.price_max', state.priceMax);
      if (state.sort && state.sort !== 'manual') p.set('filter.sort', state.sort);
      const qs = p.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }

    function matches(card, state) {
      const ds = card.dataset;
      if (state.category) {
        // Category filter reads data-type (Shopify product.type, handleized).
        // If data-type is missing (legacy/partial deploy), fall back to tags.
        if (ds.type) {
          if (ds.type !== state.category) return false;
        } else {
          const tags = (ds.tags || '').trim().split(/\s+/);
          if (tags.indexOf(state.category) === -1) return false;
        }
      }
      if (state.vendor.length && state.vendor.indexOf(ds.vendor) === -1) return false;
      if (state.concern.length) {
        const cs = (ds.concerns || '').trim().split(/\s+/);
        let any = false;
        for (let i = 0; i < state.concern.length; i++) {
          if (cs.indexOf(state.concern[i]) !== -1) { any = true; break; }
        }
        if (!any) return false;
      }
      if (state.onSale && ds.onSale !== '1') return false;
      if (state.onDrop && ds.onDrop !== '1') return false;
      const price = parseInt(ds.price, 10);
      if (state.priceMin != null && price < state.priceMin) return false;
      if (state.priceMax != null && price > state.priceMax) return false;
      return true;
    }

    function sortCards(state) {
      const arr = cards.slice();
      switch (state.sort) {
        case 'price-asc':
          arr.sort(function (a, b) { return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10); });
          break;
        case 'price-desc':
          arr.sort(function (a, b) { return parseInt(b.dataset.price, 10) - parseInt(a.dataset.price, 10); });
          break;
        case 'title-asc':
          arr.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
          break;
        case 'novedad':
          // No created_at on the card — fall back to reversed position so the
          // most recently added (last in collection order) lands at the top.
          arr.sort(function (a, b) { return parseInt(b.dataset.position, 10) - parseInt(a.dataset.position, 10); });
          break;
        default:
          arr.sort(function (a, b) { return parseInt(a.dataset.position, 10) - parseInt(b.dataset.position, 10); });
      }
      arr.forEach(function (c) { grid.appendChild(c); });
    }

    function renderChips(state) {
      if (!chipsHost) return;
      chipsHost.innerHTML = '';

      function addChip(label, onRemove, klass) {
        const a = document.createElement('a');
        a.href = '#';
        a.className = 'gs-chip' + (klass ? ' ' + klass : '');
        const text = document.createElement('span');
        text.textContent = label;
        const x = document.createElement('span');
        x.className = 'x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        a.appendChild(text);
        a.appendChild(x);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          onRemove();
          history.pushState({}, '', buildURL(state));
          applyState();
        });
        chipsHost.appendChild(a);
      }

      let activeCount = 0;
      if (state.category) {
        // Replace hyphens with spaces so "lip-tint" reads as "lip tint" in the chip.
        const catLabel = state.category.replace(/-/g, ' ');
        addChip('★ ' + catLabel, function () { state.category = ''; }, 'gs-chip--fill');
        activeCount++;
      }
      state.vendor.slice().forEach(function (v) {
        addChip(v, function () { state.vendor = state.vendor.filter(function (x) { return x !== v; }); });
        activeCount++;
      });
      state.concern.slice().forEach(function (c) {
        addChip(c, function () { state.concern = state.concern.filter(function (x) { return x !== c; }); });
        activeCount++;
      });
      if (state.onSale) {
        addChip('★ en oferta', function () { state.onSale = false; }, 'gs-chip--coral');
        activeCount++;
      }
      if (state.onDrop) {
        addChip('★ en drop', function () { state.onDrop = false; });
        activeCount++;
      }
      if (state.priceMin != null || state.priceMax != null) {
        const lo = state.priceMin != null ? ('$' + state.priceMin) : '$0';
        const hi = state.priceMax != null ? ('$' + state.priceMax) : '$∞';
        addChip(lo + '–' + hi, function () { state.priceMin = null; state.priceMax = null; });
        activeCount++;
      }

      if (activeCount > 0) {
        const clear = document.createElement('a');
        clear.href = location.pathname;
        clear.className = 'gs-chip gs-chip--clear';
        clear.textContent = 'limpiar filtros →';
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          history.pushState({}, '', location.pathname);
          applyState();
        });
        chipsHost.appendChild(clear);
      }

      // Mobile-toggle counter
      document.querySelectorAll('[data-gs-mobile-toggle-count]').forEach(function (el) {
        el.textContent = activeCount > 0 ? (' · ' + activeCount) : '';
      });
    }

    function updateSidebar(state) {
      document.querySelectorAll('[data-gs-toggle-key="category"]').forEach(function (el) {
        el.classList.toggle('on', el.dataset.gsToggleValue === state.category);
      });
      document.querySelectorAll('[data-gs-toggle-key="vendor"]').forEach(function (el) {
        el.classList.toggle('is-on', state.vendor.indexOf(el.dataset.gsToggleValue) !== -1);
      });
      document.querySelectorAll('[data-gs-toggle-key="concern"]').forEach(function (el) {
        el.classList.toggle('on', state.concern.indexOf(el.dataset.gsToggleValue) !== -1);
      });
      document.querySelectorAll('[data-gs-toggle-key="on_sale"]').forEach(function (el) {
        el.classList.toggle('is-on', state.onSale);
      });
      document.querySelectorAll('[data-gs-toggle-key="drop"]').forEach(function (el) {
        el.classList.toggle('is-on', state.onDrop);
      });
      document.querySelectorAll('input[name="filter.price_min"]').forEach(function (i) {
        i.value = state.priceMin != null ? state.priceMin : '';
      });
      document.querySelectorAll('input[name="filter.price_max"]').forEach(function (i) {
        i.value = state.priceMax != null ? state.priceMax : '';
      });
      if (sortSelect) sortSelect.value = state.sort;
    }

    function applyState() {
      const state = parseState();
      let visible = 0;
      cards.forEach(function (card) {
        const ok = matches(card, state);
        card.classList.toggle('is-hidden', !ok);
        if (ok) visible++;
      });
      sortCards(state);
      document.querySelectorAll('[data-gs-matches-count]').forEach(function (el) {
        el.textContent = visible;
      });
      if (emptyEl) emptyEl.classList.toggle('is-hidden', visible !== 0);
      grid.classList.toggle('is-hidden', visible === 0);
      renderChips(state);
      updateSidebar(state);
    }

    // Delegated click handler for all sidebar toggle links
    // (category pills, vendor checkboxes, concern chips, on_sale/drop toggles)
    document.addEventListener('click', function (e) {
      const target = e.target.closest('[data-gs-toggle-key]');
      if (!target) return;
      // skip the disabled "en tu station" toggle which is a <span> not <a>
      if (target.tagName !== 'A') return;
      e.preventDefault();
      const key = target.dataset.gsToggleKey;
      const value = target.dataset.gsToggleValue || '';
      const mode = target.dataset.gsToggleMode;
      const state = parseState();

      if (mode === 'single') {
        if (state.category === value) state.category = '';
        else state.category = value;
      } else if (mode === 'multi') {
        const list = state[key];
        if (!Array.isArray(list)) return;
        const idx = list.indexOf(value);
        if (idx >= 0) list.splice(idx, 1);
        else list.push(value);
      } else if (mode === 'bool') {
        if (key === 'on_sale') state.onSale = !state.onSale;
        else if (key === 'drop') state.onDrop = !state.onDrop;
      }

      history.pushState({}, '', buildURL(state));
      applyState();
    });

    // Sort change
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const state = parseState();
        state.sort = sortSelect.value;
        history.pushState({}, '', buildURL(state));
        applyState();
      });
    }

    // Price form submit
    if (priceForm) {
      priceForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const state = parseState();
        const minVal = (priceForm.querySelector('input[name="filter.price_min"]').value || '').trim();
        const maxVal = (priceForm.querySelector('input[name="filter.price_max"]').value || '').trim();
        state.priceMin = minVal ? parseInt(minVal, 10) : null;
        state.priceMax = maxVal ? parseInt(maxVal, 10) : null;
        history.pushState({}, '', buildURL(state));
        applyState();
      });
    }

    // Delegated handler for "limpiar todo" (sidebar footer + empty-state CTA + dynamic chip)
    document.addEventListener('click', function (e) {
      const target = e.target.closest('[data-gs-clear-all]');
      if (!target) return;
      e.preventDefault();
      history.pushState({}, '', location.pathname);
      applyState();
    });

    // Browser back/forward — re-apply state from new URL
    window.addEventListener('popstate', applyState);

    // Initial run — sync UI to whatever URL was loaded
    applyState();
  })();

  // ─── Drop page countdown (Fase E) ──────────────────────────
  // Hero countdown: 4-cell d/h/m/s grid that swaps to "★ live ahora" at zero.
  // Foot CTA countdown: inline d/h text that swaps to "está live →" at zero.
  // Both read a target ISO datetime from data-* attributes.
  function pad2(n) { return String(n).padStart(2, '0'); }

  document.querySelectorAll('[data-gs-countdown]').forEach(function (root) {
    const targetIso = root.getAttribute('data-gs-countdown-target');
    if (!targetIso) return;
    const target = new Date(targetIso).getTime();
    if (isNaN(target)) return;

    const cellD = root.querySelector('[data-gs-cd-d]');
    const cellH = root.querySelector('[data-gs-cd-h]');
    const cellM = root.querySelector('[data-gs-cd-m]');
    const cellS = root.querySelector('[data-gs-cd-s]');
    const grid  = root.querySelector('[data-gs-cd-grid]');
    const live  = root.querySelector('[data-gs-cd-live]');

    function tick() {
      const diff = Math.floor((target - Date.now()) / 1000);
      if (diff <= 0) {
        if (grid) grid.classList.add('is-hidden');
        if (live) live.classList.remove('is-hidden');
        return true;
      }
      const days = Math.floor(diff / 86400);
      const hrs  = Math.floor((diff % 86400) / 3600);
      const mins = Math.floor((diff % 3600) / 60);
      const secs = diff % 60;
      if (cellD) cellD.textContent = pad2(days);
      if (cellH) cellH.textContent = pad2(hrs);
      if (cellM) cellM.textContent = pad2(mins);
      if (cellS) cellS.textContent = pad2(secs);
      return false;
    }
    if (!tick()) {
      const id = setInterval(function () { if (tick()) clearInterval(id); }, 1000);
    }
  });

  document.querySelectorAll('[data-gs-foot-countdown]').forEach(function (root) {
    const targetIso = root.getAttribute('data-gs-foot-target');
    if (!targetIso) return;
    const target = new Date(targetIso).getTime();
    if (isNaN(target)) return;

    const cellD = root.querySelector('[data-gs-foot-d]');
    const cellH = root.querySelector('[data-gs-foot-h]');
    const title = root.querySelector('.gs-drop-foot-cta__title');
    const live  = root.querySelector('[data-gs-foot-live]');

    function tick() {
      const diff = Math.floor((target - Date.now()) / 1000);
      if (diff <= 0) {
        if (title) title.classList.add('is-hidden');
        if (live)  live.classList.remove('is-hidden');
        return true;
      }
      const days = Math.floor(diff / 86400);
      const hrs  = Math.floor((diff % 86400) / 3600);
      if (cellD) cellD.textContent = pad2(days);
      if (cellH) cellH.textContent = pad2(hrs);
      return false;
    }
    if (!tick()) {
      // Foot CTA only shows days+hours so 60s tick is plenty.
      const id = setInterval(function () { if (tick()) clearInterval(id); }, 60000);
    }
  });

  // ─── Quiz state machine (Fase F · tu-rutina) ────────────────
  // Estructura:
  //  - State machine sobre data-gs-quiz-screen (intro · 0..N-1 · result)
  //  - Selection sobre data-gs-quiz-q + data-gs-quiz-v + data-gs-quiz-multi
  //  - Matching engine: para cada step (data-gs-quiz-step-query) corre query
  //    contra el catálogo inline (#gs-quiz-catalog), scorea por concern + skin
  //    + budget tier, pickea top 1 por step. Fallback card si pool vacío.
  //  - Validación pipe-separated: si una línea de options tiene <2 cols,
  //    console.error y banner visible en el container del quiz.
  (function initQuiz() {
    const quizRoot = document.querySelector('[data-gs-quiz]');
    if (!quizRoot) return;

    const catalogTag  = quizRoot.querySelector('#gs-quiz-catalog');
    const configTag   = quizRoot.querySelector('#gs-quiz-config');
    let catalog = [];
    let config  = { discount_pct: 10 };
    try { catalog = JSON.parse(catalogTag.textContent || '[]'); }
    catch (e) { console.error('[quiz] catalog JSON parse error', e); }
    try { config = JSON.parse(configTag.textContent || '{}'); }
    catch (e) { console.error('[quiz] config JSON parse error', e); }

    // Validate pipe-separated options on each question. Each <button>
    // already rendered server-side from a line; what we validate here is
    // count and shape. If a question rendered zero buttons (block has
    // empty/malformed options), surface a visible error.
    quizRoot.querySelectorAll('[data-gs-quiz-q]').forEach(function (group) {
      const buttons = group.querySelectorAll('button');
      const qid = group.dataset.gsQuizQ;
      if (!buttons.length) {
        const err = document.createElement('div');
        err.className = 'gs-quiz__err';
        err.textContent = '[ERROR] pregunta "' + qid + '" sin opciones válidas. revisar el theme editor.';
        group.parentElement.insertBefore(err, group);
        console.error('[quiz] question "' + qid + '" has no rendered options — check pipe-separated format');
      }
    });

    // Build the ordered list of screen keys: intro, 0, 1, ..., result.
    const screens = Array.prototype.map.call(
      quizRoot.querySelectorAll('[data-gs-quiz-screen]'),
      function (el) { return el.dataset.gsQuizScreen; }
    );
    const questionKeys = screens.filter(function (k) { return /^\d+$/.test(k); });
    const totalQ = questionKeys.length;

    const state = { _step: 'intro' };
    quizRoot.querySelectorAll('[data-gs-quiz-q]').forEach(function (group) {
      const qid = group.dataset.gsQuizQ;
      const multi = group.dataset.gsQuizMulti === 'true';
      state[qid] = multi ? [] : null;
    });

    function showScreen(step) {
      const target = String(step);
      quizRoot.querySelectorAll('[data-gs-quiz-screen]').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.gsQuizScreen === target);
      });
      state._step = target;
      const top = quizRoot.querySelector('[data-gs-quiz-top]');
      if (top) {
        top.classList.toggle('is-hidden', target === 'intro' || target === 'result');
      }
      const stepIdx = parseInt(target, 10);
      if (!isNaN(stepIdx)) {
        const bar = quizRoot.querySelector('[data-gs-quiz-bar-fill]');
        if (bar) bar.style.width = ((stepIdx / totalQ) * 100) + '%';
        const cnt = quizRoot.querySelector('[data-gs-quiz-step-count]');
        if (cnt) cnt.textContent = 'paso ' + (stepIdx + 1) + ' de ' + totalQ;
        quizRoot.querySelectorAll('[data-gs-quiz-crumb]').forEach(function (c, i) {
          c.classList.remove('is-current', 'is-done');
          if (i < stepIdx) c.classList.add('is-done');
          if (i === stepIdx) c.classList.add('is-current');
        });
      }
      if (target === 'result') {
        const bar = quizRoot.querySelector('[data-gs-quiz-bar-fill]');
        if (bar) bar.style.width = '100%';
        renderResult();
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function refreshNextEnabled() {
      quizRoot.querySelectorAll('[data-gs-quiz-screen]').forEach(function (s) {
        const next = s.querySelector('[data-gs-quiz-go][disabled], [data-gs-quiz-go]:not([disabled])');
        const group = s.querySelector('[data-gs-quiz-q]');
        if (!next || !group) return;
        const qid = group.dataset.gsQuizQ;
        const val = state[qid];
        const ok = Array.isArray(val) ? val.length > 0 : !!val;
        next.disabled = !ok;
      });
    }

    // Option clicks
    quizRoot.querySelectorAll('[data-gs-quiz-q]').forEach(function (group) {
      const qid = group.dataset.gsQuizQ;
      const multi = group.dataset.gsQuizMulti === 'true';
      const max = parseInt(group.dataset.gsQuizMax || '3', 10);
      group.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const v = btn.dataset.gsQuizV;
          if (multi) {
            const arr = state[qid];
            const idx = arr.indexOf(v);
            if (idx >= 0) { arr.splice(idx, 1); btn.classList.remove('is-on'); }
            else if (arr.length < max) { arr.push(v); btn.classList.add('is-on'); }
          } else {
            group.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
            btn.classList.add('is-on');
            state[qid] = v;
          }
          refreshNextEnabled();
        });
      });
    });

    // Nav
    quizRoot.querySelectorAll('[data-gs-quiz-go]').forEach(function (b) {
      b.addEventListener('click', function () { showScreen(b.dataset.gsQuizGo); });
    });
    quizRoot.querySelectorAll('[data-gs-quiz-back]').forEach(function (b) {
      b.addEventListener('click', function () { showScreen(b.dataset.gsQuizBack); });
    });
    quizRoot.querySelectorAll('[data-gs-quiz-crumb]').forEach(function (c) {
      c.addEventListener('click', function () {
        const idx = parseInt(c.dataset.gsQuizCrumb, 10);
        if (idx === 0) { showScreen('0'); return; }
        const prevKey = questionKeys[idx - 1];
        const prevGroup = quizRoot.querySelector('[data-gs-quiz-screen="' + prevKey + '"] [data-gs-quiz-q]');
        if (!prevGroup) return;
        const prevId = prevGroup.dataset.gsQuizQ;
        const prevVal = state[prevId];
        const filled = Array.isArray(prevVal) ? prevVal.length > 0 : !!prevVal;
        if (filled) showScreen(String(idx));
      });
    });
    const restart = quizRoot.querySelector('[data-gs-quiz-restart]');
    if (restart) restart.addEventListener('click', function () {
      Object.keys(state).forEach(function (k) {
        if (k.charAt(0) === '_') return;
        state[k] = Array.isArray(state[k]) ? [] : null;
      });
      quizRoot.querySelectorAll('button.is-on').forEach(function (b) { b.classList.remove('is-on'); });
      refreshNextEnabled();
      showScreen('intro');
    });

    // ─── Matching engine ──────────────────────────────────────
    // step_tag_query format: "type:Lip Tint,type:Blush,drop-04,bestseller"
    // Tokens prefixed type: match product.type (case-insensitive label or
    // handle). Plain tokens match tags or vendor handles.
    function parseStepQuery(raw) {
      if (!raw) return [];
      return raw.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    }
    function productMatchesToken(prod, token) {
      if (token.indexOf('type:') === 0) {
        const typeWanted = token.slice(5).trim().toLowerCase();
        const typeWantedHandle = typeWanted.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        if ((prod.type || '').toLowerCase() === typeWanted) return true;
        if ((prod.type_handle || '') === typeWantedHandle) return true;
        return false;
      }
      const tags = (prod.tags || '').toLowerCase().split(',').map(function (t) { return t.trim(); });
      if (tags.indexOf(token.toLowerCase()) !== -1) return true;
      return false;
    }

    function scoreProduct(prod, ctx) {
      let score = 0;
      const tagList = (prod.tags || '').toLowerCase().split(',').map(function (t) { return t.trim(); });

      // Concern matches (+3 each)
      if (Array.isArray(ctx.concerns)) {
        ctx.concerns.forEach(function (c) {
          if (tagList.indexOf('concern:' + c) !== -1) score += 3;
        });
      }
      // Skin type match (+2)
      if (ctx.skin && tagList.indexOf('skin:' + ctx.skin) !== -1) score += 2;
      // Coverage match (+2)
      if (ctx.cobertura && tagList.indexOf('coverage:' + ctx.cobertura) !== -1) score += 2;
      // Vibe match (+1)
      if (ctx.vibe && tagList.indexOf('vibe:' + ctx.vibe) !== -1) score += 1;
      // Budget gating (filter): per-tier price cap
      // essential ≤ 800 · balanced ≤ 1500 · complete: no cap
      const tier = ctx.budget;
      const price = prod.price || 0;
      if (tier === 'essential' && price > 1000) score -= 2;
      if (tier === 'balanced'  && price > 1800) score -= 1;
      // Drop-04 boost as a tiebreaker
      if (tagList.indexOf('drop-04') !== -1) score += 0.5;
      // Bestseller boost as a tiebreaker
      if (tagList.indexOf('bestseller') !== -1) score += 0.25;
      return score;
    }

    function pickForStep(stepCard, ctx, usedIds) {
      const query = parseStepQuery(stepCard.dataset.gsQuizStepQuery);
      if (!query.length) return null;
      const pool = catalog.filter(function (p) {
        if (usedIds[p.id]) return false;
        return query.some(function (tok) { return productMatchesToken(p, tok); });
      });
      if (!pool.length) return null;
      pool.sort(function (a, b) { return scoreProduct(b, ctx) - scoreProduct(a, ctx); });
      return pool[0];
    }

    function formatPrice(p) {
      return '$' + p.toLocaleString('es-MX');
    }

    function renderStepCard(stepCard, product) {
      const body = stepCard.querySelector('[data-gs-quiz-step-body]');
      const visual = stepCard.querySelector('[data-gs-quiz-step-visual]');
      const fallback = stepCard.dataset.gsQuizStepFallback || 'próximamente · más opciones';
      stepCard.classList.remove('is-fallback');
      if (!product) {
        stepCard.classList.add('is-fallback');
        body.innerHTML =
          '<span class="b-name">★ próximamente</span>' +
          '<p class="gs-quiz__step-fallback-copy">' + fallback + '</p>' +
          '<a class="gs-quiz__step-fallback-link" href="/collections/all">ver opciones →</a>';
        return null;
      }
      stepCard.setAttribute('href', product.url);
      stepCard.setAttribute('data-gs-quiz-step-variant-id', product.variant_id);
      // Visual image
      if (product.image) {
        // Preserve the step-tag/when overlays; insert img before them.
        const existingImg = visual.querySelector('img');
        if (existingImg) existingImg.remove();
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        img.width = 400; img.height = 400;
        visual.insertBefore(img, visual.firstChild);
      }
      body.innerHTML =
        '<span class="b-name">' + product.vendor.toLowerCase() + '</span>' +
        '<h4 class="p-name">' + product.title.toLowerCase().replace(/^[^-–]+\s*[-–]\s*/, '') + '</h4>' +
        '<span class="pr">' + formatPrice(product.price) + '</span>';
      return product;
    }

    function renderResult() {
      const ctx = {
        skin: state.skin,
        cobertura: state.cobertura,
        vibe: state.vibe,
        budget: state.budget,
        concerns: Array.isArray(state.concerns) ? state.concerns : []
      };
      // Update vibe italic header
      const vibeEl = quizRoot.querySelector('[data-gs-quiz-vibe]');
      if (vibeEl && ctx.vibe) {
        const vibeMap = { clean: 'clean.', offduty: 'off-duty.', glam: 'glam.', editorial: 'editorial.' };
        vibeEl.textContent = vibeMap[ctx.vibe] || (ctx.vibe + '.');
      }
      // Pick one product per step, avoiding duplicates across steps
      const usedIds = {};
      let subtotal = 0;
      let pickedCount = 0;
      quizRoot.querySelectorAll('[data-gs-quiz-step]').forEach(function (stepCard) {
        const picked = pickForStep(stepCard, ctx, usedIds);
        const product = renderStepCard(stepCard, picked);
        if (product) {
          usedIds[product.id] = true;
          subtotal += product.price;
          pickedCount++;
        }
      });
      // Summary
      const subtotalEl = quizRoot.querySelector('[data-gs-quiz-summary-subtotal]');
      const discountEl = quizRoot.querySelector('[data-gs-quiz-summary-discount]');
      const totalEl    = quizRoot.querySelector('[data-gs-quiz-summary-total]');
      const strikeEl   = quizRoot.querySelector('[data-gs-quiz-summary-strike]');
      const discountRow = quizRoot.querySelector('[data-gs-quiz-summary-discount-row]');
      const subLabel   = quizRoot.querySelector('[data-gs-quiz-summary-label]');
      const addAllBtn  = quizRoot.querySelector('[data-gs-quiz-add-all]');
      if (subLabel) subLabel.textContent = pickedCount + ' productos · subtotal';
      const discountPct = parseInt(config.discount_pct || 0, 10);
      const discountAmt = Math.round(subtotal * (discountPct / 100));
      const total = subtotal - discountAmt;
      if (subtotalEl) subtotalEl.textContent = formatPrice(subtotal);
      if (discountEl) discountEl.textContent = '−' + formatPrice(discountAmt);
      if (totalEl)    totalEl.textContent = formatPrice(total);
      if (strikeEl)   strikeEl.textContent = discountPct > 0 ? formatPrice(subtotal) : '';
      if (discountRow) discountRow.style.display = (discountPct > 0 && pickedCount > 0) ? '' : 'none';
      if (addAllBtn) addAllBtn.disabled = pickedCount === 0;
    }

    // Add all 4 to cart
    const addAll = quizRoot.querySelector('[data-gs-quiz-add-all]');
    if (addAll) addAll.addEventListener('click', function () {
      const variantIds = Array.prototype.map.call(
        quizRoot.querySelectorAll('[data-gs-quiz-step-variant-id]'),
        function (el) { return el.dataset.gsQuizStepVariantId; }
      ).filter(Boolean);
      if (!variantIds.length) return;
      const items = variantIds.map(function (id) { return { id: id, quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.GS && window.GS.openCart) window.GS.openCart();
        else window.location.href = '/cart';
      })
      .catch(function (e) { console.error('[quiz] add-all error', e); });
    });

    // Share to WhatsApp
    const shareBtn = quizRoot.querySelector('[data-gs-quiz-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      const titles = Array.prototype.map.call(
        quizRoot.querySelectorAll('.gs-quiz__step-body .p-name'),
        function (el) { return '★ ' + el.textContent; }
      ).join('\n');
      const text = encodeURIComponent('mi rutina glamstation:\n' + titles + '\n→ ' + window.location.href);
      window.open('https://wa.me/?text=' + text, '_blank');
    });

    // Keyboard: Enter advances if next is enabled
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      const active = quizRoot.querySelector('.gs-quiz__screen.is-active');
      if (!active) return;
      const btn = active.querySelector('[data-gs-quiz-go]:not([disabled])');
      if (btn) btn.click();
    });

    refreshNextEnabled();
  })();

  // expose open/close for other scripts
  window.GS = window.GS || {};
  window.GS.openCart = function () { fetchCart().then(renderCart).then(openCartDrawer); };
  window.GS.closeCart = closeCartDrawer;
  window.GS.openFilters = openFiltersSheet;
  window.GS.closeFilters = closeFiltersSheet;
})();
